import { useState } from "react";
import { BASE_URL, UPLOAD_IMAGES } from "../utils/constants";
import { useGetUniversitiesQuery } from "./useGetUniversitiesQuery";

const serverUrl = BASE_URL?.endsWith("/") ? BASE_URL.slice(0, -1) : BASE_URL;

export function useIES() {
const [cacheBuster] = useState(Date.now());

  const { data, isLoading, error } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 1 }, 
    {
        refetchOnWindowFocus: false,
        retry: false,
        keepPreviousData: true,
    }
  );

  const university = data?.items?.[0];
  const IES = {
    NAME: university?.description ?? "N/A",
    NUIT: university?.nuit ?? "N/A",
    CODE: university?.code ?? "N/A",
    EMAIL: university?.email ?? "N/A",
    PHONE_NUMBER: university?.dirigentPhoneNumber ?? "N/A",
    ENROLLMENT_DEPARTAMENT_NAME: "N/A",
    LOGO: `${serverUrl}${UPLOAD_IMAGES}/logo?t=${cacheBuster}`,
    BACKGROUND: `${serverUrl}${UPLOAD_IMAGES}/background?t=${cacheBuster}`,
    FAVICON: `${serverUrl}${UPLOAD_IMAGES}/favicon?t=${cacheBuster}`,
    COUNTRY: university?.province ?? "N/A",
    CITY: university?.address ?? "N/A",
    MINIMUM_PASSING_GRADE: university?.minimumPassingGrade ?? 9.5,
    SHOW_STUDENTS_GRADE_WITH_DEBT: university?.showStudentsGradeWithDebt,
  };

  //     const IES = useMemo(() => {
  //   // if (!university) return null;

  //   return {
  //     NAME: university?.description ?? "N/A",
  //     NUIT: university?.nuit ?? "N/A",
  //     CODE: university?.code ?? "N/A",
  //     EMAIL: university?.email ?? "N/A",
  //     PHONE_NUMBER: university?.dirigentPhoneNumber ?? "N/A",
  //     ENROLLMENT_DEPARTAMENT_NAME:  "N/A",
  //     LOGO: `${serverUrl}${UPLOAD_IMAGES}/logo`,
  //     BACKGROUND: `${serverUrl}${UPLOAD_IMAGES}/background`,
  //     FAVICON: `${serverUrl}${UPLOAD_IMAGES}/favicon`,
  //     COUNTRY: university?.province ?? "N/A",
  //     CITY: university?.address ?? "N/A",
  //     MINIMUM_PASSING_GRADE: university?.minimumPassingGrade ?? 9.5,
  //   };
  // }, [university]);

  return { IES, isLoading, error };
}
